import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAlignLeft,
  faArrowLeft,
  faArrowRight,
  faAnglesLeft,
  faAnglesRight,
  faBan,
  faBarcode,
  faBriefcase,
  faCalendarAlt,
  faCamera,
  faCheck,
  faCheckCircle,
  faClockRotateLeft,
  faCloudUploadAlt,
  faCommentAlt,
  faDownload,
  faEdit,
  faEllipsisV,
  faExchangeAlt,
  faExclamationCircle,
  faEye,
  faEyeSlash,
  faFile,
  faFileCode,
  faFileCsv,
  faFileLines,
  faFolder,
  faFolderOpen,
  faForward,
  faGlassMartini,
  faGlobeAmericas,
  faImage,
  faInfoCircle,
  faLink,
  faUnlink,
  faList,
  faListAlt,
  faLocation,
  faMobileAlt,
  faPlus,
  faPlusCircle,
  faQuestionCircle,
  faSave,
  faSearch,
  faShare,
  faShareSquare,
  faSignInAlt,
  faSignOutAlt,
  faSort,
  faSortDown,
  faSortUp,
  faSync,
  faTachometerAlt,
  faTag,
  faTags,
  faTimes,
  faTimesCircle,
  faTrashCan,
  faUndo,
  faUser,
  faUserCog,
  faUserGraduate,
  faUserLock,
  faUsersCog,
  faWeight,
  faWrench,
  faXmark,
  faHashtag
} from '@fortawesome/free-solid-svg-icons'

library.add(faAlignLeft)
library.add(faArrowLeft)
library.add(faArrowRight)
library.add(faAnglesLeft)
library.add(faAnglesRight)
library.add(faBan)
library.add(faBarcode)
library.add(faBriefcase)
library.add(faCalendarAlt)
library.add(faCamera)
library.add(faCheck)
library.add(faCheckCircle)
library.add(faClockRotateLeft)
library.add(faCloudUploadAlt)
library.add(faCommentAlt)
library.add(faDownload)
library.add(faEdit)
library.add(faEllipsisV)
library.add(faExchangeAlt)
library.add(faExclamationCircle)
library.add(faEye)
library.add(faEyeSlash)
library.add(faFile)
library.add(faFileCode)
library.add(faFileCsv)
library.add(faFileLines)
library.add(faFolder)
library.add(faFolderOpen)
library.add(faForward)
library.add(faGlassMartini)
library.add(faGlobeAmericas)
library.add(faHashtag)
library.add(faImage)
library.add(faInfoCircle)
library.add(faLink)
library.add(faUnlink)
library.add(faList)
library.add(faListAlt)
library.add(faLocation)
library.add(faMobileAlt)
library.add(faPlus)
library.add(faPlusCircle)
library.add(faQuestionCircle)
library.add(faSave)
library.add(faSearch)
library.add(faShare)
library.add(faShareSquare)
library.add(faSignInAlt)
library.add(faSignOutAlt)
library.add(faSort)
library.add(faSortDown)
library.add(faSortUp)
library.add(faSync)
library.add(faTachometerAlt)
library.add(faTag)
library.add(faTags)
library.add(faTimes)
library.add(faTimesCircle)
library.add(faTrashCan)
library.add(faUndo)
library.add(faUser)
library.add(faUserCog)
library.add(faUserGraduate)
library.add(faUserLock)
library.add(faUsersCog)
library.add(faWeight)
library.add(faWrench)
library.add(faXmark)

export default FontAwesomeIcon
